/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
} from './SortDirection';

/**
 * 
 * @export
 * @interface PageSort
 */
export interface PageSort {
    /**
     * 
     * @type {SortDirection}
     * @memberof PageSort
     */
    sortDirection: SortDirection;
}



/**
 * Check if a given object implements the PageSort interface.
 */
export function instanceOfPageSort(value: object): value is PageSort {
    if (!('sortDirection' in value) || value['sortDirection'] === undefined) return false;
    return true;
}

export function PageSortFromJSON(json: any): PageSort {
    return PageSortFromJSONTyped(json, false);
}

export function PageSortFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageSort {
    if (json == null) {
        return json;
    }
    return {
        
        'sortDirection': SortDirectionFromJSON(json['sortDirection']),
    };
}

export function PageSortToJSON(value?: PageSort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sortDirection': SortDirectionToJSON(value['sortDirection']),
    };
}

